"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceButtonLabel = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var styles_1 = require("../../../styles");
var border = styles_1.COLOR.border, background = styles_1.COLOR.background;
var labelBackgroundColorStyle = function (error, focus) {
    if (focus) {
        return background.white;
    }
    if (error) {
        return background.error;
    }
    return background.white;
};
var labelBorderColorStyle = function (error, focus) {
    if (focus && error) {
        return border.error;
    }
    if (focus) {
        return border.focus;
    }
    if (error) {
        return border.error;
    }
    return border.base;
};
var labelBoxShadowStyle = function (error, focus) {
    if (!focus) {
        return '';
    }
    if (error) {
        return '0px 0px 0px 2px rgba(232, 75, 53, 0.5)';
    }
    return '0px 0px 0px 2px rgba(15, 128, 233, 0.50)';
};
exports.ChoiceButtonLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  line-height: 1.5;\n  font-size: 16px;\n  padding: 8px 16px;\n  border: 1px solid;\n  border-radius: 4px;\n  cursor: pointer;\n  background: ", ";\n  border-color: ", ";\n  box-shadow: ", ";\n  transition:\n    border-color 0.2s ease-out,\n    box-shadow 0.2s ease-out,\n    background-color 0.2s ease-out;\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  display: flex;\n  line-height: 1.5;\n  font-size: 16px;\n  padding: 8px 16px;\n  border: 1px solid;\n  border-radius: 4px;\n  cursor: pointer;\n  background: ", ";\n  border-color: ", ";\n  box-shadow: ", ";\n  transition:\n    border-color 0.2s ease-out,\n    box-shadow 0.2s ease-out,\n    background-color 0.2s ease-out;\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (_a) {
    var error = _a.error, focus = _a.focus;
    return labelBackgroundColorStyle(error, focus);
}, function (_a) {
    var error = _a.error, focus = _a.focus;
    return labelBorderColorStyle(error, focus);
}, function (_a) {
    var error = _a.error, focus = _a.focus;
    return labelBoxShadowStyle(error, focus);
}, background.disabled, border.base);
var templateObject_1;
